class War {
    constructor(age, name, text, cost, effect)
    {
        this.age = age;
        this.name = name;
        this.text = text;
        this.cost = cost;
        this.effect = effect;
    }

    GetAge() {
        return this.age;
    }

    GetName() {
        return this.name;
    }

    GetText() {
        return this.text;
    }

    GetCost() {
        return this.cost;
    }
    GetEffects = () => this.effect;
}

module.exports = War;